import {useAppDispatch} from '../../../hooks/redux'
import {closeModal} from '../../../redux/features/modal'

import {formatPrice} from '../../../libs/formatter'

import ActionBar from '../../../../../commons/src/components/action-bar'
import Headline from '../../../../../commons/src/components/headline'
import Modal from '../../../../../commons/src/components/modal'
import Paragraph from '../../../../../commons/src/components/paragraph'
import Stack from '../../../../../commons/src/components/stack'
import OrderTag from '../../../components/order-tag'

import {Order, OrderRefund} from '../../../order-types'
import AdditionalCostPartial from '../../order/additional-cost-partial'
import ModelTablePartial from '../../order/model-table-partial'

type Props = {
  order: Order
  refund: OrderRefund
}

const PartialRefundDetails = ({order, refund}: Props) => {
  const dispatch = useAppDispatch()

  const currency =
    order.amounts.cartItems?.currency ||
    order.amounts.shipping?.currency ||
    order.amounts.additionalCosts?.currency ||
    ''

  const refundQuoteIds = (refund.quotes || []).map(quote => quote.quoteId)
  const refundQuotes =
    refund.quotes && refund.quotes.length > 0
      ? order.quotes.filter(quote => refundQuoteIds.includes(quote.quoteId))
      : []

  const refundAdditionalCosts =
    order.additionalCosts && refund.additionalCosts && refund.additionalCosts.length > 0
      ? order.additionalCosts.filter(additionalCost =>
          refund.additionalCosts?.includes(additionalCost.id)
        )
      : []

  const refundHasShipping =
    order.shipping &&
    refund.shippings &&
    refund.shippings.length > 0 &&
    refund.shippings.includes(order.shipping?.shippingId)

  return (
    <Modal
      size="xl"
      headline={<Headline label="Partial Refund Items" size="l" className="u-no-margin-bottom" />}
      onClose={() => dispatch(closeModal())}
    >
      <Stack space="300">
        {refundQuotes.length > 0 && (
          <Stack>
            <Headline size="s" minor label="Models" />
            <ModelTablePartial order={order} quotes={refundQuotes} minified />
          </Stack>
        )}
        {refundAdditionalCosts.length > 0 && (
          <Stack>
            <Headline size="s" minor label="Additional Costs" />
            {refundAdditionalCosts.map(additionalCost => (
              <AdditionalCostPartial
                key={additionalCost.id}
                additionalCost={additionalCost}
                hidePostFix
              />
            ))}
          </Stack>
        )}
        {refundHasShipping && (
          <Stack>
            <Headline size="s" minor label="Shipping" />
            <ActionBar noWrap alignItems="top">
              <Paragraph className="u-no-margin-bottom" size="s">
                {order.shipping.name}
              </Paragraph>
              {order.shipping.type === 'express' && <OrderTag type="express" />}
              <Paragraph className="u-no-margin-bottom" strong size="s">
                {formatPrice(order.amounts.shipping.netPrice, currency, 2)}
              </Paragraph>
            </ActionBar>
          </Stack>
        )}
      </Stack>
    </Modal>
  )
}

export default PartialRefundDetails
